import { isPresent } from 'shared/lib/utils';
import { planTiers } from '@/lib/config';

export function subscriptionPlanTier(user) {
  if (user.getIn(['billing', 'subscriptionActive']) === false) {
    return null;
  }

  const matchingSubscriptionPlanTier = Object.entries(planTiers)
    .flatMap(([_tierKey, tiers]) =>
      Object.entries(tiers).map(([_tierCycleKey, tier]) => tier)
    )
    .filter(
      (tier) => tier.id === user.getIn(['billing', 'subscriptionPlanId'])
    );

  if (matchingSubscriptionPlanTier.length < 1) {
    return null;
  }

  return matchingSubscriptionPlanTier[0];
}

export function isStoryAuthor(user, story) {
  return user && story.getIn(['author', 'id']) === user.get('id');
}

export function isPaidPlanSubscriber(user) {
  return isPresent(subscriptionPlanTier(user));
}

export function isFreePlanSubscriber(user) {
  return !!user.get('subscribedToFreePlanAt');
}

export function firstName(user) {
  return isPresent(user.get('name')) && user.get('name').split(' ')[0];
}
